module.exports = __webpack_public_path__ + "69d3324362b899270dcdf0161e22ca96.fbx";